import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleExSolidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M16 28.8a12.8 12.8 0 1 0 0-25.6 12.8 12.8 0 0 0 0 25.6m-4.5-17.2q1-.8 1.7 0l2.8 2.7 2.7-2.7q1-.8 1.7 0a1 1 0 0 1 0 1.6L17.7 16l2.7 2.7q.8 1 0 1.7t-1.7 0L16 17.7l-2.8 2.7q-.8.7-1.7 0-.6-.8 0-1.7l2.8-2.7-2.8-2.8c-.4-.4-.4-1.2 0-1.6"
	})
});
export default SvgCircleExSolidIcon;
